<template>
  <b-modal v-model="show" size="lg" @close="onCancel">
    <template v-slot:modal-title>Confirm</template>
    <div class="my-2">
      <div v-html="message"></div>
    </div>
    <template v-slot:modal-footer>
      <b-button type="submit" variant="primary" @click="onConfirm">Yes</b-button>
      <b-button type="reset" variant="danger" @click="onCancel">No</b-button>
    </template>
  </b-modal>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      resolve: null,
      reject: null,
      message: ""
    };
  },
  methods: {
    open(message) {
      this.message = message;
      this.show = true;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    onConfirm() {
      this.resolve(true);
      this.show = false;
    },
    onCancel() {
      this.resolve(false);
      this.show = false;
    }
  }
};
</script>
